// Hike Embed Entrypoint
// Lightweight entrypoint for iframe embeds - no analytics, no auth, minimal dependencies

// Import styles (CSS file is loaded via vite_stylesheet_tag in layout)
import './hike_embed.css';

// Embeds don't use Firebase auth — unblock anything in the shared GraphQL
// client that awaits authReady, otherwise requests hang indefinitely.
import { signalAuthReady } from '../utils/firebase/authReady';
signalAuthReady();

// Initialize the embed app
import '../apps/hike_map_embed/main';
